import { render, staticRenderFns } from "./DriverWalletTab.vue?vue&type=template&id=01b394b2&"
import script from "./DriverWalletTab.vue?vue&type=script&lang=js&"
export * from "./DriverWalletTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports